import { render, staticRenderFns } from "./baas-frame.vue?vue&type=template&id=6ae39123"
import script from "./baas-frame.vue?vue&type=script&lang=js"
export * from "./baas-frame.vue?vue&type=script&lang=js"
import style0 from "./baas-frame.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/baas/baas-frame.vue
// module id = LLlp
// module chunks = 0